export default __webpack_public_path__ + "static/media/grid_1__10.2482c3d5.jpg";